import { render, staticRenderFns } from "./NXTCustomUserSelector.vue?vue&type=template&id=4a9aaa50&scoped=true"
import script from "./NXTCustomUserSelector.vue?vue&type=script&lang=js"
export * from "./NXTCustomUserSelector.vue?vue&type=script&lang=js"
import style0 from "./NXTCustomUserSelector.vue?vue&type=style&index=0&id=4a9aaa50&prod&scoped=true&lang=css"
import style1 from "./NXTCustomUserSelector.vue?vue&type=style&index=1&id=4a9aaa50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9aaa50",
  null
  
)

export default component.exports